// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607071458/js/" + chunkId + "." + {"44":"a3ab796e","225":"3e97e5b4","481":"cfe7cbb5","486":"badac3a7","770":"05d6ffed"}[chunkId] + ".0.833289848056866.chunk.js";
};